import React, { useState,useEffect } from "react";
import { Link, useNavigate,useParams } from 'react-router-dom'
import axios from "axios";
import { schoolsurl } from '../../../apis/urls';



const EditMember = () => {

    let schools = localStorage.getItem('schoolid')
    console.log(schools)

    
    useEffect(() => {
        editlisting();
    },[]
    );

    let navigate = useNavigate();


    const RoutToList = (id) =>{
        let path = 'newPath'; 
        navigate("/members/"+sid)
    }


    const [res,setRes] = useState([]);
    const [username,setUsername] = useState('');
    const [role,setRole] = useState('');
    const [password,setPassword] = useState('');
    const [confirmPassword,setConfirmPassword] = useState('');
    const [status,setStatus] = useState('');
    const [schoolid, setSchoolid] = useState('');

    const [nameerror,setNameerror] = useState(false);

    const { id,sid } = useParams();
    
    const editlisting = () => {
        
        let token = "Bearer "+localStorage.getItem('token');
        const instance = axios.create({
            baseURL: schoolsurl+'/'+sid+"/users/"+id,
            timeout: 1000000,
            headers: {'authorization': token}
            });
            instance.get('').then((response) =>{ 
            setRes(response.data.data);
            setUsername(response.data.data.username);
            setRole(response.data.data.role);
            setStatus(response.data.data.status);
            }).catch((error) =>{
            
            console.log('error',error.message)
            

            });
    }

    const onEditForm = () => {
        let error = 0;
        if(username === '')
        {
            setNameerror(true)
            error =1;
        } 
        if(role === '')
        {
            setNameerror(true)
            error =1;
        }  
        if(status === '')
        {
            setNameerror(true)
            error =1;
        }  
        

        if(error === 0) 
        {
            let token = "Bearer "+localStorage.getItem('token');     
            const data = {
                username: username,
                role: role,
                status :status
            }           
            const instance = axios.create({
                baseURL: schoolsurl+"/"+sid+"/users/"+id,
                timeout: 1000000,
                headers: {'authorization': token}
            });
            instance.put('',data).then((response) =>{      
                navigate("/members/"+sid)
                
            }).catch((error) =>{
                console.log('error',error.message)
            });
        }           
    }

    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column"> 
                            <h2 className="page-title">Edit Member Account</h2>
                        </div>
                        <div className="page-rightside-action-column">               
                        </div>  
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/school_list">Schools</Link></li>
                            <li className="breadcrumb-item"><Link to={"/members/"+sid}>Permissions</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Edit Member</li>
                        </ol>
                    </nav>


                    <div className="form-wrpr">
                        <div class="card formcard small">
                            <div class="card-body">

                                <div className="form-group">
                                <label className="degreehead">Username <span style={{color: "red"}}>*</span></label>
                                <input type="text" className="form-control bg-dark dark-theme showtext"
                                onChange={e => {setUsername(e.target.value)}} defaultValue={res.username}  id="name"></input>
                                </div>

                                <div className="form-group">
                                    <label className="degreehead">Role <span style={{color: "red"}}>*</span></label>
                                    <select className="form-control bg-dark dark-theme showtext"
                                    onChange={e => {setRole(e.target.value)}}  defaultValue={res.username} id="status-selector">
                                        <option value="0">Select Role</option>
                                       
                                        <option value="ATHLETIC_MANAGER" selected = {res.role === "ATHLETIC_MANAGER"}>ATHLETIC DIRECTOR</option>
                                        <option value="HO_SCHOOL" selected = {res.role === "HO_SCHOOL"}>HEAD OF SCHOOL</option>
                                    </select>
                                </div>

                                <div class="form-group text-right">
                                    <button className="btn btn-danger btn-gisa" onClick={()=> { RoutToList(id)} } type="submit">Cancel</button>
                                    <button onClick={onEditForm} className="btn btn-primary btn-gisa" type="button">Update</button>
                                </div>

                            </div>
                        </div>
                    </div>


                </div>
            </aside>
        </div>
    )
}

export default EditMember;